export const faqCategories = [
  {
    title: "General Questions",
    icon: "Info",
    faqs: [
      {
        question: "What is RSC?",
        answer:
          "RSC is a hassle-free marketplace where you can sell your items instantly. We handle all logistics and pay you in cash at the best market rates—no listings, no waiting, no negotiations.",
      },
      {
        question: "How does RSC work?",
        answer:
          "Simply request an instant offer, ship your items with our prepaid label, and get paid quickly once the items are inspected.",
      },
      {
        question:
          "Why should I sell to RSC instead of eBay or Facebook Marketplace?",
        answer:
          "Unlike eBay or Facebook Marketplace, RSC offers instant pricing, guaranteed sales, no buyer negotiations, and fast, secure payments.",
      },
      {
        question: "Who can use RSC?",
        answer:
          "Anyone 18+! Whether you're an individual selling a few items, a reseller flipping products, or a business clearing inventory, RSC is built for you.",
      },
    ],
  },
  {
    title: "Selling & Payment",
    icon: "Wallet",
    faqs: [
      {
        question: "How do I sell my items?",
        answer:
          "1. Request a quote on your items.\n2. Accept the offer and ship your items using our prepaid shipping label.\n3. Once inspected, you get paid quickly via PayPal or ACH.",
      },
      {
        question: "How fast do I get paid?",
        answer:
          "Payments are typically processed within 48 hours after inspection.",
      },
      {
        question: "How do I receive my payment?",
        answer: "We offer PayPal and ACH (bank transfer).",
      },
      {
        question: "What if I find a higher offer elsewhere?",
        answer:
          "We offer price matching and may even beat the average payouts from sites like eBay.",
      },
    ],
  },
  {
    title: "Shipping & Logistics",
    icon: "Package",
    faqs: [
      {
        question: "Who covers shipping costs?",
        answer:
          "RSC provides prepaid shipping labels—you never pay for shipping.",
      },
      {
        question: "Are my items insured during shipping?",
        answer:
          "Yes! Every shipment is fully insured at no extra cost, ensuring you're protected.",
      },
      {
        question: "How do I track my shipment?",
        answer:
          "You'll receive a tracking number and real-time status updates from our system.",
      },
      {
        question: "What happens if my item is lost in transit?",
        answer:
          "Since all shipments are insured, you're fully covered if an item is lost or damaged in transit.",
      },
    ],
  },
  {
    title: "Pricing & Offers",
    icon: "DollarSign",
    faqs: [
      {
        question: "How are item prices determined?",
        answer:
          "We use real-time market data and AI-driven pricing models to offer the best possible payouts.",
      },
      {
        question: "Do prices fluctuate?",
        answer:
          "Yes, prices may change based on market demand, condition, and inventory levels.",
      },
      {
        question: "Can I negotiate my offer?",
        answer:
          "Our offers are based on market conditions, but we offer price matching if you find a better deal.",
      },
    ],
  },
  {
    title: "Account & Membership Benefits",
    icon: "Trophy",
    faqs: [
      {
        question: "Does RSC have a rewards program?",
        answer:
          "Yes! The more you sell, the more you earn—unlock higher-tier status, better payouts, and exclusive perks.",
      },
      {
        question: "What are the membership levels?",
        answer:
          "Our tiered system rewards high-volume sellers with benefits like:\n• Trusted: Priority payouts & cashback bonuses\n• Whale: Increased offers & faster processing\n• Beluga: VIP support, highest payouts, and exclusive deals\n• Blue Whale: Invite Only, Personal Contact",
      },
      {
        question: "Are there any fees to use RSC?",
        answer: "No! There are no hidden fees or seller commissions.",
      },
    ],
  },
  {
    title: "Security & Trust",
    icon: "Shield",
    faqs: [
      {
        question: "Is selling on RSC safe?",
        answer:
          "Yes! We use AI-powered fraud detection, secure payments, and insured shipping to protect sellers.",
      },
      {
        question: "What if I have an issue with my transaction?",
        answer:
          "Our dedicated support team is available to help with any concerns or disputes.",
      },
      {
        question: "How do I contact customer support?",
        answer:
          "You can reach us via email, discord, or our support portal for assistance.",
      },
    ],
  },
];
